exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-link{margin:0;display:flex;flex-direction:column;align-items:center;justify-content:center;text-decoration:none}@media (min-width:1023px){.search-link{height:auto;width:auto;flex-direction:row;padding:5px 10px;border-radius:4px;margin:5px 5px 5px 0;cursor:pointer}}.search-link__text{font-size:var(--font-normal);white-space:nowrap;color:var(--black)}.search-link__icon{width:22px}.search-link__icon path{fill:var(--black)}@media (min-width:1023px){.search-link__icon{width:15px;margin-right:5px}.search-link__icon path{fill:var(--black)}}", ""]);

// exports
